export enum NewsletterFrequency {
  MultiDaily = 5,
  Daily = 1,
  Weekly = 2,
  AdHoc = 4,
}
